export default __webpack_public_path__ + "static/media/background.6ff01d2c.png";